import $ from 'jquery';

function openShare(e) {
  e.stopPropagation();
  const $targetShareWidget = $(e.target).closest('.article-meta-wrap');
  const $otherShareWidgets = $('.article-meta-wrap').not($targetShareWidget);

  $targetShareWidget.addClass('active');
  $otherShareWidgets.removeClass('active');
}

function closeShare(e) {
  if (!$(e.target).closest('.share-widget-toggle').length && !$(e.target).closest('.share-widget').length) {
    $('.article-meta-wrap').removeClass('active');
  }
}

export default class Share {
  constructor({ el }) {
    this.el = el;
    this.shareWidgetToggles = this.el.querySelectorAll('.share-widget-toggle');
    this.onBodyClick = e => closeShare(e);
    this.onShareClick = e => openShare(e);

    if (!this.shareWidgetToggles) {
      return;
    }

    document.body.addEventListener('click', this.onBodyClick);
    this.shareWidgetToggles.forEach((el) => {
      el.addEventListener('click', this.onShareClick);
    });
  }

  unload() {
    document.body.removeEventListener('click', this.onBodyClick);

    if (this.shareWidgetToggles) {
      this.shareWidgetToggles.forEach((el) => {
        el.removeEventListener('click', this.onShareClick);
      });
    }
  }
}
